import { onlineManager, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { keepPreviousFilteredData } from '@/api/keepPreviousFilteredData';
import { PageLoader } from '@/components/common/PageLoader';
import { RouteErrorState } from '@/components/common/RouteErrorState';

onlineManager.setOnline(navigator.onLine);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'offlineFirst',
      retry: (failureCount) => onlineManager.isOnline() && failureCount < 1,
      refetchOnWindowFocus: true,
      placeholderData: keepPreviousFilteredData,
    },
  },
});

const router = createRouter({
  routeTree,
  defaultPendingComponent: PageLoader,
  defaultPendingMinMs: 200,
  defaultErrorComponent: RouteErrorState,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
